module.exports = __webpack_public_path__ + "static/media/beijing-2@2x.0c475cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/beijing-2@2x.png
// module id = 1630
// module chunks = 0